export default [
    {
        path: 'baixa',
        component: () => import(/* weimunizacaockChunkName: 'imunizacao-baixa' */ '@/views/imunizacao/baixa/Index'),
        redirect: 'baixa/index',
        children: [
            {
                name: 'imunizacao-baixa-index',
                path: 'index',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-baixa' */ '@/views/imunizacao/baixa/List.vue'),
            },
        ],
    },
]